import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgResReport = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12 10V17.8M8.5 17.8V13.5M18.944 8H16.5996C16.0396 8 14.7598 7.99998 14.5459 7.89099C14.3577 7.79512 14.2049 7.64218 14.109 7.45401C14 7.2401 14 5.96005 14 5.4V3M15.5 13V17.8M19 17.8V7.65399C19.0435 6.89099 18.8315 6.26068 19 7C19 7 18.9148 6.5 18.7332 6.18499C18.6208 5.99002 18.4632 5.81997 18.1483 5.47986L16.9502 4.02588C16.6002 3.64789 16.425 3.45888 16.2168 3.32343C16.0322 3.20337 16.3118 3.23656 15.6151 3.06077C15.3743 3 15.1172 3 14.6021 3H8.2002C7.08009 3 6.51962 3 6.0918 3.21799C5.71547 3.40973 5.40973 3.71572 5.21799 4.09204C5 4.51986 5 5.07991 5 6.20001V17.8C5 18.9201 5 19.4801 5.21799 19.908C5.40973 20.2843 5.71547 20.5902 6.0918 20.782C6.51962 21 7.08009 21 8.2002 21H15.8002C16.9203 21 17.48 21 17.9078 20.782C18.2841 20.5902 18.5905 20.2843 18.7822 19.908C19.0002 19.4801 19 18.9201 19 17.8Z",
		stroke: "#324051",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgResReport;
